// https://tc39.github.io/proposal-setmap-offrom/#sec-set.of
require('./_set-collection-of')('Set');



//////////////////
// WEBPACK FOOTER
// /home/circleci/repo/~/core-js/modules/es7.set.of.js
// module id = 1367
// module chunks = 168707334958949